import { render, staticRenderFns } from "./UserProfileFull.vue?vue&type=template&id=c81ee1a8&scoped=true&"
import script from "./UserProfileFull.vue?vue&type=script&lang=js&"
export * from "./UserProfileFull.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileFull.vue?vue&type=style&index=0&id=c81ee1a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81ee1a8",
  null
  
)

export default component.exports